"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 元数据中表达式需要的一些函数
 */

// {{***}} 
var reg = /^\s*\{{2}([\s\S]+)\}{2}\s*$/m;

// {{{***}}}
var reg1 = /^\s*\{{3}([\s\S]+)\}{3}\s*$/m;

function isExpression(v) {
    return reg.test(v) || reg1.test(v);
}

function getExpressionBody(v) {
    if (reg1.test(v)) {
        //去掉前后{{{ }}}
        return v.replace(reg1, function (word, group) {
            return group;
        });
    }

    if (reg.test(v)) {
        //return + 去掉前后{{ }}
        return "return " + v.replace(reg, function (word, group) {
            return group;
        });
    }

    return v;
}

exports.default = {
    isExpression: _lodash2.default.memoize(isExpression),
    getExpressionBody: _lodash2.default.memoize(getExpressionBody)
};
module.exports = exports["default"];